import {
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest
}                        from '@angular/common/http';
import { Injectable }    from '@angular/core';
import {
	HEADER_CLIENT_INTERCEPTOR,
	IHeaderClientInterceptor,
	InterceptorXHeaderIdentifierEnum
}                        from '@interceptors/interceptors.model';
import { LoggerService } from '@shared/services/logger.service';
import { Observable }    from 'rxjs';

@Injectable()
export class XClientInterceptor implements HttpInterceptor {
	private readonly _headerClientInterceptor: IHeaderClientInterceptor = {
		clientIdentifier: 'FCP',
		enabled: true,
		xHeader: InterceptorXHeaderIdentifierEnum.HEADER_CLIENT
	};

	constructor(
		private readonly logger: LoggerService
	) {}

	intercept( req: HttpRequest<any>, next: HttpHandler ): Observable<HttpEvent<any>> {

		const headerClientInterceptor: IHeaderClientInterceptor = req.context.get( HEADER_CLIENT_INTERCEPTOR );

		if ( headerClientInterceptor.enabled ) {
			req = req.clone( { headers: req.headers.set( headerClientInterceptor.xHeader, headerClientInterceptor.clientIdentifier ) } );
		} else { // Todo keep this as long all api calls are not refactored to support HttpContext
			req = req.clone( { headers: req.headers.set( this._headerClientInterceptor.xHeader, this._headerClientInterceptor.clientIdentifier ) } );
		}

		this.logger.trace( 'XClientInterceptor req', req );
		return next.handle( req );
	}
}
